module.exports = __webpack_public_path__ + "img/end_place.7d78e2d9.png";